import { Marquee } from "../ui/Marquee"



const reviewStarImages = [
  {
    src: "/image/heroupdated/trust.svg",
    alt: "Trust",
    href: "https://www.trustindex.io/reviews/urfx.io",
  },
  {
    src: "/image/heroupdated/advice.svg",
    alt: "Advisor",
    href: "https://www.trustsadvisor.com/businesses/urfx.io",
  },
  {
    src: "/image/heroupdated/proven.svg",
    alt: "expert",
    href: "https://www.provenexpert.com/en-us/urfx-io/",
  },
  
]
    

export function ReviewSlider({ variant = "landing" }: { variant?: "landing" | "programs" }) {
  const isVertical = variant === "programs"; // Determines if the marquee should be vertical

  return (
    <>
      <div className={`relative w-full flex-row items-center justify-center overflow-hidden flex ${isVertical ? "flex-col max-h-[300px]" : ""}`}>
        
        {/* Marquee that will adjust direction based on `variant` */}
        <Marquee pauseOnHover vertical={isVertical} className="items-center [--duration:10s] [--gap:1rem]">
          {reviewStarImages.map((src, idx) => (
            <a href={src.href} target="_blank" key={`${src}-${idx}`}>
            <img
              key={`${src.src}-${idx}`}
              src={src.src}
              alt={src.alt}
              className="h-14 w-auto mx-auto shrink-0 object-contain opacity-90"
              loading="lazy"
            />
            </a>
          ))}
        </Marquee>

        {/* Left and Right Black Gradient Shadows */}
        {/* <div className={`pointer-events-none absolute left-0 w-1/4 h-full bg-gradient-to-l from-transparent to-black ${isVertical ? "hidden" : ""}`} /> */}
        {/* <div className={`pointer-events-none absolute right-0 w-1/4 h-full bg-gradient-to-l to-transparent from-black ${isVertical ? "hidden" : ""}`} /> */}
      </div>
    </>
  )
}